(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-related"] && !Shopify.designMode) return;
  try {
    function scrollRelatedProducts(direction) {
    const productsDiv = document.getElementById('relatedProductsDiv');
    const scrollAmount = 280; // Approximate width of one product plus gap
    
    if (direction === 'left') {
      productsDiv.scrollBy({
        left: -scrollAmount,
        behavior: 'smooth'
      });
    } else {
      productsDiv.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      });
    }
    
    // Update button visibility after scrolling
    setTimeout(updateRelatedScrollButtons, 300);
  }

  function updateRelatedScrollButtons() {
    const productsDiv = document.getElementById('relatedProductsDiv');
    const leftBtn = document.getElementById('scrollLeftBtnRelated');
    const rightBtn = document.getElementById('scrollRightBtnRelated');
    
    if (!productsDiv || !leftBtn || !rightBtn) return;
    
    const isAtStart = productsDiv.scrollLeft <= 0;
    const isAtEnd = productsDiv.scrollLeft >= (productsDiv.scrollWidth - productsDiv.clientWidth - 1);
    
    // Show/hide left button
    leftBtn.style.display = isAtStart ? 'none' : 'flex';
    
    // Show/hide right button
    rightBtn.style.display = isAtEnd ? 'none' : 'flex';
  }

  // Add scroll event listener to update buttons during manual scrolling
  function initializeRelatedScrollButtons() {
    const productsDiv = document.getElementById('relatedProductsDiv');
    if (productsDiv) {
      productsDiv.addEventListener('scroll', updateRelatedScrollButtons);
      // Initial update
      setTimeout(updateRelatedScrollButtons, 500);
    }
  }

  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
          // Initialize scroll buttons after content is loaded
          setTimeout(initializeRelatedScrollButtons, 500);
        }
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });

  observer.observe(productRecommendationsSection);
  } catch(e) { console.error(e); }
})();

})();
